import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    ordenesFacturacionLogistica: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    transporte: null,
    incluirAnulados: false,
    pendientesFacturar: false,
    sortByDescending: true,

    ordenDatos: [],
    ordenRenglonesDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_ORDENES' (state) {
        state.ordenesFacturacionLogistica = [];
    },
    'SET_ORDENES' (state, ordenesFacturacionLogistica) {
        // state.ordenesFacturacionLogistica = ordenesFacturacionLogistica;

        state.ordenesFacturacionLogistica = ordenesFacturacionLogistica
            .map( ordenFacturacionLogistica => ({ ...ordenFacturacionLogistica, _rowVariant: ordenFacturacionLogistica.facturado ? '' : 'danger'  }) );

    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_DATOS' (state) {
        state.ordenDatos = [];
        state.ordenRenglonesDatos = [];
    },
    'SET_ORDEN_DATOS' (state, params) {
        state.ordenDatos = params.ordenDatos;
        state.ordenRenglonesDatos = params.ordenRenglonesDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    getOrdenes ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_ORDENES');

            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD')
                + '&sortByDescending='+ state.sortByDescending;
            
            if (state.paginaActual != 0) {
              queryString += '&pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
            }
            if (state.transporte) {
                if (state.transporte.id != 0) {
                    queryString += '&transporteId=' + state.transporte.id;
                }
            }
            if ((/true/i).test(state.incluirAnulados)) {
                queryString += '&incluirAnulados=true';
            }
            if ((/true/i).test(state.pendientesFacturar)) {
                queryString += '&pendientesFacturar=true';
            }
            
            apiAxios.get('ordenesfacturacionlogistica' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_ORDENES', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    delete ( {}, ordenFacturacionLogisticaId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('ordenesfacturacionlogistica/' + ordenFacturacionLogisticaId + '/delete')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    getDatos ( { commit }, ordenFacturacionLogisticaId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (ordenFacturacionLogisticaId) {
                apiAxios.get('ordenesfacturacionlogistica/' + ordenFacturacionLogisticaId ) 
                    .then(res => {
                        let ordenDatos = [
                            { 'nombre': 'fechaComprobante', 'campo': 'Fecha de Comp.', 'valor': res.data.fechaComprobante, 'formato': 'fecha' },
                            { 'nombre': 'transporte', 'campo': 'Transporte', 'valor': res.data.transporte, 'formato': '' },
                            { 'nombre': 'comprobante', 'campo': 'Comprobante', 'valor': res.data.comprobante, 'formato': '' },
                            { 'nombre': 'numero', 'campo': 'Numero', 'valor': res.data.numero, 'formato': '' },
                            { 'nombre': 'montoTotal', 'campo': 'Total', 'valor': res.data.montoTotal, 'formato': 'moneda' },
                            { 'nombre': 'facturado', 'campo': 'Facturada', 'valor': res.data.facturado? 'Si' : 'No', 'formato': '' },
                            { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones, 'formato': '' },
                            { 'nombre': 'usuario', 'campo': 'Usuario', 'valor': res.data.usuario, 'formato': '' },
                        ]

                        var params = {
                            ordenDatos,
                            ordenRenglonesDatos: res.data.renglones,
                        }
                                      
                        commit('SET_ORDEN_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        }, error => {
            reject(error);
        })            
    },   
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}